import ReactDOM from 'react-dom';
import videojs from 'video.js';
import SpeedSelector from './SpeedSelector';
const vjsComponent = videojs.getComponent('Component');
class MenuSpeedSelector extends vjsComponent {
    constructor(player, options) {
        super(player, options);
        /* Bind the current class context to the mount method */
        this.mount = this.mount.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleUpdatedRate = this.handleUpdatedRate.bind(this);
        /* When player is ready, call method to mount React component */
        player.ready(() => {
            this.mount();
        });
        /* Remove React root when component is destroyed */
        this.on('dispose', () => {
            ReactDOM.unmountComponentAtNode(this.el());
        });
        this.on('tap', (e) => {
            this.handleClick(e);
        });
        player.on('updateSelectedRate', (_event, args) => {
            this.handleUpdatedRate(args.rate);
        });
    }
    buildCSSClass() {
        return `vjs-speed-selector-buttons ${super.buildCSSClass()}`;
    }
    handleUpdatedRate(rate) {
        const prevOption = this.$('.selected');
        const newOption = this.$(`button[value="${rate}"]`);
        if (prevOption && newOption && Number(prevOption.value) !== rate) {
            prevOption.classList.remove('selected');
            newOption.classList.add('selected');
            this.player().playbackRate(rate);
        }
    }
    handleClick(e) {
        const prevSelectedOption = this.$('.selected');
        if (!(e.target instanceof HTMLButtonElement))
            return;
        const newSelectedOption = e.target;
        //ignore if value is not being updated
        if ((newSelectedOption === null || newSelectedOption === void 0 ? void 0 : newSelectedOption.innerHTML) === (prevSelectedOption === null || prevSelectedOption === void 0 ? void 0 : prevSelectedOption.innerHTML)) {
            return;
        }
        prevSelectedOption.classList.remove('selected');
        newSelectedOption.classList.add('selected');
        const newPlaybackRate = newSelectedOption.value;
        this.setPlaybackRate(newPlaybackRate);
    }
    setPlaybackRate(speed) {
        const speedNumber = Number(speed);
        this.player().playbackRate(speedNumber);
        this.player().trigger('playbackRateChanged', { rate: speedNumber });
    }
    /**
     * We will render out the React SpeedSelector component into the DOM element
     * generated automatically by the VideoJS createEl() method.
     *
     * We fetch that generated element using `this.el()`, a method provided by the
     * vjsComponent class that this class is extending.
     */
    mount() {
        const options = [{ value: 0.8 }, { value: 1.0 }, { value: 1.3 }, { value: 1.6 }, { value: 2.0 }];
        const player = this.player();
        this.addClass('vjs-speed-selector-buttons');
        this.addChild(new SpeedSelector(player, {}, { type: 'playback-rate', default: 1, handleClick: this.handleClick, options }));
    }
}
export default MenuSpeedSelector;
//# sourceMappingURL=MenuSpeedSelector.js.map